var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6.709 1.804 C 6.917 1.969 7.008 2.24 6.943 2.497 C 6.333 4.894 7.181 7.426 9.113 8.971 C 11.044 10.517 13.701 10.789 15.906 9.667 C 16.142 9.547 16.426 9.576 16.633 9.741 C 16.84 9.907 16.931 10.178 16.866 10.435 C 15.996 13.85 12.906 16.229 9.381 16.196 C 5.857 16.163 2.812 13.727 2.005 10.296 C 1.199 6.865 2.841 3.328 5.982 1.729 C 6.218 1.609 6.503 1.638 6.709 1.804 Z",
    fill: "rgb(179, 179, 179)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/MoonIcon.7d9047b740586f1ce27dc15c8a185f93.svg";
export { ForwardRef as ReactComponent };